
import { useEffect, useState } from "react";
import { api } from "../../../utils/api";

export default function Timer({ phoneNumber }) {
	const TIME_LEFT = 60;
	const [timeLeft, setTimeLeft] = useState(TIME_LEFT);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		if (timeLeft === 0) return;
		const timer = setInterval(() => {
			setTimeLeft((prevTime) => prevTime - 1);
		}, 1000);
		return () => clearInterval(timer);
	}, [timeLeft]);

	const formatTime = (time) => {
		const minutes = Math.floor(time / 60);
		const seconds = time % 60;
		return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
	};

	const resendVerificationCode = () => {
		if (isLoading || !phoneNumber) return;
		setIsLoading(true);
		setErrorMessage("");
		api.profileLogin({
			phone_number: phoneNumber,
		})
			.then(() => {
				setIsLoading(false);
				setTimeLeft(TIME_LEFT);
			})
			.catch((err) => {
				setIsLoading(false);
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	};

	return (
		<div className="text-center py-1">
			{timeLeft === 0 ? (
				<button
					type="button"
					disabled={isLoading}
					onClick={resendVerificationCode}
					className="font-Vazir-600 text-[13px] text-darkBlue px-4 py-2 rounded-xl border border-[#E2E8F0] bg-white hover:bg-lightCta disabled:opacity-60 cursor-pointer"
				>
					{isLoading ? "در حال ارسال…" : "ارسال مجدد کد"}
				</button>
			) : (
				<p className="font-Vazir-400 text-[13px] text-grayText">
					ارسال مجدد تا{" "}
					<span className="font-Vazir-600 text-midGray tabular-nums" dir="ltr">
						{formatTime(timeLeft)}
					</span>
				</p>
			)}
			{errorMessage ? (
				<p className="text-center font-Vazir-400 text-[13px] text-error mt-2">{errorMessage}</p>
			) : null}
		</div>
	);
}
